import $ from 'jquery';
import {
  forEach as _forEach,
  throttle as _throttle,
  trim as _trim,
} from 'lodash-es';
import utilLib from '../_util';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = '.wrapper h2[id]';
let lastPassedItem = 0;
let count = 0;
let saveHeadline = [];
// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class headlineScroll {
  constructor(el) {
    this.el = el;
    this.$headline = $(el);
    this.anchors = [];
    this._activeItem = null;

    this.$indexList = $('.content-menu .swiper-wrapper');

    $(window).on('scroll resize load', _throttle(this.updateNav.bind(this)));
    this.crawlAnchors();
    this.buildNav();
    this.updateNav();
  }

  get activeItem() {
    return this._activeItem;
  }

  set activeItem(i) {
    if (i !== this._activeItem) {
      this._activeItem = i;
      this.$indexList.find('li').removeClass('active').eq(i).addClass('active');
    }
  }

  crawlAnchors() {
    this.$headline.each((i, e) => {
      $('<span class="scroll-anchor"></span>').appendTo($(e))
      const id = _trim(e.id.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/gi, ''));
      const label = _trim(e.getAttribute('id'));
      const waypoint = $(e).find('.scroll-anchor')[0];

      if (saveHeadline.includes(label) || id == 'kontakt') {
        return;
      }

      count += 1;
      let pos = count;

      e.setAttribute('id', id);

      if (id && label) {
        this.anchors.push({ id, label, waypoint, pos });
        saveHeadline.push(label);
      }
    });
  }

  buildNav() {
    _forEach(this.anchors, (anchor) => {
      const newstring = anchor.label.replaceAll('--','_____').replaceAll('-',' ').replaceAll('_____',' -');
      this.$indexList.append(`<li class="swiper-slide"><a href="#${anchor.id}">${newstring}</a></li>`);
    });
  }

  updateNav() {
    const winScrollPos = utilLib.getWindowScrollPos();

    _forEach(this.anchors, (anchor, i) => {
      const offset = utilLib.getElementOffset(anchor.waypoint);
      if (Math.ceil(winScrollPos.top) >= Math.floor(offset.top)) {
        lastPassedItem = anchor.pos;
      }
    });
    this.activeItem = lastPassedItem;

  }

  observer() {
    const observerElement = this.$headline;
    const headerHeight = $('.header').height();
    var wasAbove = false;
    let scrollPos = 'down';

    var lastScrollTop = 0;

    document.addEventListener('scroll', function () {
      var st = window.pageYOffset || document.documentElement.scrollTop;
      if (st > lastScrollTop) {
        scrollPos = 'down';
      } else {
        scrollPos = 'up';
      }
      lastScrollTop = st <= 0 ? 0 : st;
    }, false);


    const contentObserver = new IntersectionObserver(elements => {
      for (const element of elements) {
        const isAbove = element.boundingClientRect.y < element.rootBounds.y;

        if (element.isIntersecting) {
          $(`.content-menu [href]`).parent().removeClass('active');
          $(`.content-menu [href="#${element.target.id}"]`).parent().addClass('active');

          if ($(window).width() < 767) {
            if (scrollPos == 'down') {

              setTimeout(function () {
                if (!document.querySelector(`.content-menu li:first-child`).classList.contains('active')) {
                  $('.content-menu .swiper-button-next').trigger('click');
                }
              }, 500);


            } else {
              $('.content-menu .swiper-button-prev').trigger('click');
            }
          }
        }
        wasAbove = isAbove;
      }
    }, {
      rootMargin: '-205px 0px 0px 0px',
      // threshold: 0.25
    });

    _forEach(observerElement, (item) => {
      contentObserver.observe(item);
    });
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`${baseClass}`).each((i, el) => new headlineScroll(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
